export default class MobileNavigation {
  constructor(element) {
    this.element = element;

    if (!!this.element) {
      this.attachEvents();
    }
  }

  eventListener = event => {
    if (event.target.closest('[data-js="open-mobile-nav-sidebar"]')) {
      this.openSidebar();
    }

    if (event.target.closest('[data-js="close-mobile-nav-sidebar"]')) {
      this.closeSidebar();
    }

    if (event.target.matches('[data-sub-menu-target]')) {
      this.openSubMenu(event);
    }

    if (event.target.matches('[data-close-sub-menu]')) {
      this.closeSubMenu(event);
    }
  };

  attachEvents() {
    document.addEventListener('click', this.eventListener, false);
  }

  detachEvents() {
    document.removeEventListener('click', this.eventListener, false);
  }

  openSidebar() {
    this.element
      .querySelector('[data-js="mobile-nav-sidebar"]')
      .classList.add('mobile-navigation__sidebar--open');
  }

  closeSidebar() {
    this.element
      .querySelector('[data-js="mobile-nav-sidebar"]')
      .classList.remove('mobile-navigation__sidebar--open');
  }

  openSubMenu(event) {
    const target = event.target.attributes['data-sub-menu-target'].value;

    this.element
      .querySelector(`[data-sub-menu="${target}"]`)
      .classList.add('mobile-navigation__sub-menu--active');
  }

  closeSubMenu(event) {
    const target = event.target.attributes['data-close-sub-menu'].value;

    this.element
      .querySelector(`[data-sub-menu="${target}"]`)
      .classList.remove('mobile-navigation__sub-menu--active');
  }
}
